import Vue from "vue";

/**
 * 列表
 * @param params
 * @returns {*}
 */
export function liveGuaranteeLockList(params) {
  return Vue.axios({
    url: '/api/live_guarantee_lock/list',
    method: 'get',
    params
  })
}

/**
 * 信息
 * @param lock_at
 * @returns {*}
 */
export function liveGuaranteeLockGetInfo(lock_at) {
  return Vue.axios({
    url: '/api/live_guarantee_lock/info',
    method: 'get',
    params: {lock_at: lock_at}
  })
}

/**
 * 筛选项
 * @param year
 * @returns {*}
 */
export function liveGuaranteeLockGetLockYmList(year) {
  return Vue.axios({
    url: '/api/live_guarantee_lock/lockYmList',
    method: 'get',
    params: {lock_year: year}
  })
}

/**
 * 最近锁定时间
 * @returns {*}
 */
export function liveGuaranteeLockGetLastLock() {
  return Vue.axios({
    url: '/api/live_guarantee_lock/lastLock',
    method: 'get'
  })
}

/**
 * 设置锁定
 * @param lock_at
 * @returns {*}
 */
export function liveGuaranteeLockSetLock(lock_at) {
  return Vue.axios({
    url: '/api/live_guarantee_lock/lock',
    method: 'get',
    params: {lock_at: lock_at}
  })
}

/**
 * 设置解锁
 * @param lock_at
 * @returns {*}
 */
export function liveGuaranteeLockSetUnlock(lock_at) {
  return Vue.axios({
    url: '/api/live_guarantee_lock/unlock',
    method: 'get',
    params: {lock_at: lock_at}
  })
}